import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CacheService } from 'src/app/core/services/cache/cache.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import {
    AbstractControl,
    FormControl,
    FormGroup,
    ValidationErrors,
    ValidatorFn,
} from '@angular/forms';
import { Institution, TypeExportEnum } from 'src/app/shared/models/institution';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { ToastService } from 'src/app/core/services/toast/toast.service';
import * as saveAs from 'file-saver';
import { ECharts, EChartsOption } from 'echarts';
import { ModuleType, NatureAbandon, NatureAbandonAnnulation, NatureAbandonString, Prestation, PrestationStatut, PrestationStatutColor, PrestationType, StatutBeneficiaire, StatutBeneficiaireString } from 'src/app/shared/models/prestation';
import * as echarts from 'echarts';
import { Beneficiaire } from 'src/app/shared/models/beneficiaire';
import { firstValueFrom } from 'rxjs';
import { GenreType } from 'src/app/shared/models/employee/genre-type';
import { NiveauEtude } from 'src/app/shared/models/niveauEtude';
import { ActivitePrestation } from 'src/app/shared/models/activitePrestation';
import { Service } from 'src/app/shared/models/service';
import { TypeHandicap } from 'src/app/shared/models/typeHandicap';
import { Region } from 'src/app/shared/models/region';
import { Departement } from 'src/app/shared/models/departement';
import { Prescripteur } from 'src/app/shared/models/prescripteur';
import { AideType, AideTypeStringEnum, RestitutionPrestation } from 'src/app/shared/models/restitutionPrestation';

@Component({
    selector: 'app-institution-form',
    templateUrl: './institution-form.component.html',
    styleUrls: ['./institution-form.component.scss']
})
export class InstitutionFormComponent implements OnInit {

    institution = new Institution();
    loadingReport: boolean;
    loadingActivityReport: boolean;
    imgSrc1: string;
    imgSrc2: string;
    imgSrc3: string;
    imgSrc4: string;
    imgSrc5: string;
    imgSrc6: string;
    imgSrc7: string;
    imgSrc8: string;
    imgSrc9: string;
    imgSrc10: string;
    imgSrc11: string;
    imgSrc12: string;
    imgSrc13: string;
    imgSrc14: string;

    isValidateButtonClicked: { value: boolean } = { value: false };
    listPrestation: Prestation[] = [];
    listNiveauEtude: NiveauEtude[];
    listOptionHandicapPrincipal: string[] = [];
    listService: Service[];
    listRegion: Region[];
    listTypeHandicap: TypeHandicap[];
    prescripteurList: string[] = [];
    selectedService: Service;
    selectedRegion: Region;
    selectedTypeHandicap: TypeHandicap;
    selectedDepartement: Departement[] = [];
	restitutions : RestitutionPrestation[] = [];

    showServiceField: boolean = false;
    showRegionField: boolean = false;
    showHandicapField: boolean = false;
    public TypeExportEnum = TypeExportEnum;

    MAX_NAME_CHAR = 25;
    NAME_PATTERN =
        "^[0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+( [0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+)*$";

    systemForm = new FormGroup({
        smtpHost: new FormControl(''),
        smtpPswd: new FormControl(''),
        smtpUserName: new FormControl(''),
        smtpPort: new FormControl(),
        gedHost: new FormControl(''),
        gedPswd: new FormControl(''),
        gedUsername: new FormControl(''),
        gedPort: new FormControl(),
        dateDebut: new FormControl(),
        dateFin: new FormControl(),
        dateDebutRA: new FormControl(),
        dateFinRA: new FormControl(),
        typeExport: new FormControl(),
        service: new FormControl(),
        region: new FormControl(),
        typeHandicap: new FormControl(),
    });

    constructor(
        private facade: FacadeService,
        private logger: LogService,
        private toastService: ToastService,
        private cache: CacheService
    ) { }

    ngOnInit(): void {
        this.facade.institutionService.getInstitution().subscribe({
            next: (val) => {
                this.institution = val;
                this.systemForm.patchValue({
                    smtpHost: this.institution.smtpHost,
                    smtpPswd: this.institution.smtpPswd,
                    smtpUserName: this.institution.smtpUserName,
                    smtpPort: this.institution.smtpPort,
                    gedHost: this.institution.gedHost,
                    gedPswd: this.institution.gedPswd,
                    gedUsername: this.institution.gedUsername,
                    gedPort: this.institution.gedPort,
                });
            },
            error: (err) => {
                this.logger.error(err);
            }
        });

        this.facade.niveauEtudeService.getAllNiveauEtude().subscribe({
            next: (val) => {
                this.listNiveauEtude = val;
            },
            error: (err) => {
                this.logger.error(err);
            }
        });

        this.facade.typeHandicapService.getAllTypeHandicaps().subscribe({
            next: (val) => {
                this.listTypeHandicap = val;
            },
            error: (err) => {
                this.logger.error(err);
            }
        });

        this.facade.departementService.getAllDepartement().subscribe({
            next: (val) => {
                this.selectedDepartement = val;
            },
            error: (err) => {
                this.logger.error(err);
            }
        });

        this.facade.serviceService.getServicesByUser(this.facade.dataStorageService.getUser().id).subscribe({
            next: (val) => {
                this.listService = val;
            },
            error: (err) => {
                this.logger.error(err);
            }
        });

        //this.selectedService = this.facade.dataStorageService.getService();

    }

    async generateImageRepPresEnFctPrest(): Promise<string> {
        return new Promise((resolve) => {
            const hiddenDiv = document.createElement('div');
            hiddenDiv.style.position = 'absolute';
            hiddenDiv.style.width = '650px';
            hiddenDiv.style.height = '400px';
            hiddenDiv.style.left = '-9999px';
            document.body.appendChild(hiddenDiv);

            const chart = echarts.init(hiddenDiv);

            const options: EChartsOption = {
                title: {
                    text: 'Répartition des prescriptions reçues en fonction des prestations',
                    left: 'center',
                    top: 20,
                    textStyle: {
                        color: '#262c5e',
                        fontFamily: 'Comfortaa, cursive'
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                },
                series: [
                    {
                        type: 'pie',
                        radius: '55%',
                        center: ['50%', '60%'],
                        data: Object.values(ModuleType).map(module => ({
                            name: module,
                            value: this.listPrestation!.filter(e => e.typePrestation == module).length
                        })),
                        label: {
                            show: true,
                            formatter: '{b}: {c} ({d}%)',
                            fontSize: 14
                        }
                    }
                ]
            };

            chart.setOption(options);
            chart.resize();

            setTimeout(() => {
                const base64Image = chart.getDataURL({
                    type: 'png',
                    pixelRatio: 2,
                    backgroundColor: '#fff',
                });

                chart.dispose();
                document.body.removeChild(hiddenDiv);

                resolve(base64Image);
            }, 200);
        });
    }

    async generateChartImgRepPrescByDpt(): Promise<string> {
        return new Promise((resolve) => {
            const hiddenDiv = document.createElement('div');
            hiddenDiv.style.width = '650px';
            hiddenDiv.style.height = '400px';
            hiddenDiv.style.position = 'absolute';
            hiddenDiv.style.top = '-9999px';
            hiddenDiv.style.left = '-9999px';
            document.body.appendChild(hiddenDiv);

            const chart = echarts.init(hiddenDiv);

            const options: EChartsOption = {
                title: {
                    text: 'Répartition géographique des prescriptions',
                    left: 'center',
                    top: 20,
                    textStyle: {
                        color: '#262c5e',
                        fontFamily: 'Comfortaa, cursive'
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                },
                series: [
                    {
                        type: 'pie',
                        radius: '55%',
                        center: ['50%', '60%'],
                        data: this.selectedDepartement.map(p => ({
                            name: p.name + "(" + p.code + ")",
                            value: this.listPrestation!.filter(e => e.typePrestation == PrestationType.QD &&
                                e.beneficiaire != null && e.beneficiaire.departement != null && e.beneficiaire.departement?.id == p.id).length
                        })),
                        label: {
                            show: true,
                            formatter: '{b}: {c} ({d}%)',
                            fontSize: 14,
                            overflow: 'break'
                        }
                    }
                ]
            };

            chart.setOption(options);
            chart.resize();

            setTimeout(() => {
                const base64Image = chart.getDataURL({
                    type: 'png',
                    pixelRatio: 2,
                    backgroundColor: '#fff',
                });

                chart.dispose();
                document.body.removeChild(hiddenDiv);

                resolve(base64Image);
            }, 200);
        });
    }

    async generateChartImgNbPrescByMonthBarChart(): Promise<string> {
        return new Promise((resolve) => {
            const hiddenDiv = document.createElement('div');
            hiddenDiv.style.width = '650px';
            hiddenDiv.style.height = '400px';
            hiddenDiv.style.position = 'absolute';
            hiddenDiv.style.top = '-9999px';
            hiddenDiv.style.left = '-9999px';
            document.body.appendChild(hiddenDiv);

            const chart = echarts.init(hiddenDiv);

            // Étape 1 : Filtrer les prestations de type QD
            const prestationsQD = this.listPrestation?.filter(p => p.typePrestation === PrestationType.QD) ?? [];

            // Étape 2 : Grouper par mois
            const prestationCountsByMonth: Record<string, number> = {};
            prestationsQD.forEach(p => {
                const date = new Date(p.dateDebut); // Remplace par le champ correct si différent
                const key = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0'); // ex: 2025-06

                if (!prestationCountsByMonth[key]) {
                    prestationCountsByMonth[key] = 0;
                }
                prestationCountsByMonth[key]++;
            });

            // Étape 3 : Trier les mois
            const sortedMonths = Object.keys(prestationCountsByMonth).sort();

            // Étape 4 : Extraire les données pour l'axe X et les valeurs
            const labels = sortedMonths.map(m => {
                const [year, month] = m.split('-');
                return `${month}/${year}`; // ex: 06/2025
            });
            const values = sortedMonths.map(m => prestationCountsByMonth[m]);

            const options: EChartsOption = {
                title: {
                    text: 'Nombre de prescriptions par mois',
                    left: 'center',
                    top: 20,
                    textStyle: {
                        color: '#262c5e',
                        fontFamily: 'Comfortaa, cursive'
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                xAxis: {
                    type: 'category',
                    data: labels,
                    axisLabel: {
                        rotate: 45
                    }
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: values,
                    type: 'bar',
                    barWidth: '40%',
                    itemStyle: {
                        color: '#FFC744'
                    },
                    label: {
                        show: true,
                        position: 'top'
                    }
                }]
            };

            chart.setOption(options);
            chart.resize();

            setTimeout(() => {
                const base64Image = chart.getDataURL({
                    type: 'png',
                    pixelRatio: 2,
                    backgroundColor: '#fff',
                });

                chart.dispose();
                document.body.removeChild(hiddenDiv);

                resolve(base64Image);
            }, 200);
        });
    }

    async generateChartImgRepBenefBySex(): Promise<string> {
        return new Promise((resolve) => {
            const hiddenDiv = document.createElement('div');
            hiddenDiv.style.position = 'absolute';
            hiddenDiv.style.width = '650px';
            hiddenDiv.style.height = '400px';
            hiddenDiv.style.left = '-9999px';
            document.body.appendChild(hiddenDiv);

            const chart = echarts.init(hiddenDiv);

            const options: EChartsOption = {
                title: {
                    text: 'Répartition des bénéficiaires par sexe',
                    left: 'center',
                    top: 20,
                    textStyle: {
                        color: '#262c5e',
                        fontFamily: 'Comfortaa, cursive'
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                },
                series: [
                    {
                        type: 'pie',
                        radius: ['40%', '70%'],
                        center: ['50%', '60%'],
                        data: [
                            {
                                name: 'Femmes', value: this.listPrestation.filter(e => e.typePrestation == PrestationType.QD
                                    && e.beneficiaire != null && e.beneficiaire.genre != null && e.beneficiaire.genre == GenreType.F).length
                            },
                            {
                                name: 'Hommes', value: this.listPrestation.filter(e => e.typePrestation == PrestationType.QD
                                    && e.beneficiaire != null && e.beneficiaire.genre != null && e.beneficiaire.genre == GenreType.M).length
                            },
                        ],
                        label: {
                            show: true,
                            formatter: '{b}: {c} ({d}%)',
                            fontSize: 14,
                            overflow: 'break'
                        }
                    }
                ]
            };

            chart.setOption(options);
            chart.resize();

            setTimeout(() => {
                const base64Image = chart.getDataURL({
                    type: 'png',
                    pixelRatio: 2,
                    backgroundColor: '#fff',
                });

                chart.dispose();
                document.body.removeChild(hiddenDiv);

                resolve(base64Image);
            }, 200);
        });
    }

    async generateChartImgRepBenefByAge(): Promise<string> {
        return new Promise((resolve) => {
            const hiddenDiv = document.createElement('div');
            hiddenDiv.style.width = '650px';
            hiddenDiv.style.height = '400px';
            hiddenDiv.style.position = 'absolute';
            hiddenDiv.style.top = '-9999px';
            hiddenDiv.style.left = '-9999px';
            document.body.appendChild(hiddenDiv);

            const chart = echarts.init(hiddenDiv);

            // Étape 1 : Filtrer les prestations de type QD
            const prestationsQD = this.listPrestation?.filter(p => p.typePrestation === PrestationType.QD) ?? [];

            // Étape 4 : Extraire les données pour l'axe X et les valeurs
            const labels = ['16-20 ANS', '21-30 ANS', '31-40 ANS', '41-50 ANS', '51-60 ANS', '> 60 ANS'];
            const counts: Record<string, number> = {
                '16-20 ANS': 0,
                '21-30 ANS': 0,
                '31-40 ANS': 0,
                '41-50 ANS': 0,
                '51-60 ANS': 0,
                '> 60 ANS': 0
            };

            prestationsQD.forEach(b => {
                if (b.beneficiaire != null && b.beneficiaire.birthDate != null) {
                    const age = this.calculerAge(b.beneficiaire.birthDate);
                    if (age >= 16 && age <= 20) counts['16-20 ANS']++;
                    else if (age <= 30) counts['21-30 ANS']++;
                    else if (age <= 40) counts['31-40 ANS']++;
                    else if (age <= 50) counts['41-50 ANS']++;
                    else if (age <= 60) counts['51-60 ANS']++;
                    else if (age > 60) counts['> 60 ANS']++;
                }
            });

            // 4. Générer les données
            const data = labels.map(tranche => counts[tranche]);

            const options: EChartsOption = {
                title: {
                    text: "Répartition des bénéficiaires par tranches d'âge",
                    left: 'center',
                    top: 20,
                    textStyle: {
                        color: '#262c5e',
                        fontFamily: 'Comfortaa, cursive'
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                xAxis: {
                    type: 'category',
                    data: labels,
                    axisLabel: {
                        rotate: 45,
                        overflow: 'break'
                    }
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: data,
                    type: 'bar',
                    barWidth: '40%',
                    itemStyle: {
                        color: '#FFC744'
                    },
                    label: {
                        show: true,
                        position: 'top'
                    }
                }]
            };

            chart.setOption(options);
            chart.resize();

            setTimeout(() => {
                const base64Image = chart.getDataURL({
                    type: 'png',
                    pixelRatio: 2,
                    backgroundColor: '#fff',
                });

                chart.dispose();
                document.body.removeChild(hiddenDiv);

                resolve(base64Image);
            }, 200);
        });
    }

    async generateChartImgRepBenefByNiveau(): Promise<string> {
        return new Promise((resolve) => {
            const hiddenDiv = document.createElement('div');
            hiddenDiv.style.width = '650px';
            hiddenDiv.style.height = '550px';
            hiddenDiv.style.position = 'absolute';
            hiddenDiv.style.top = '-9999px';
            hiddenDiv.style.left = '-9999px';
            document.body.appendChild(hiddenDiv);

            const chart = echarts.init(hiddenDiv);

            // Étape 1 : Filtrer les prestations de type QD
            const prestationsQD = this.listPrestation?.filter(p => p.typePrestation === PrestationType.QD) ?? [];

            const niveauCounts: Record<string, number> = {};
            const labels = [];
            this.listNiveauEtude.forEach(nd => {
                niveauCounts[nd.name] = 0;
                labels.push(nd.name);
            });

            prestationsQD.forEach(b => {
                if (b.beneficiaire != null && b.beneficiaire.niveauEtude != null) {
                    niveauCounts[b.beneficiaire.niveauEtude.name]++;
                }
            });

            // 4. Générer les données
            const data = labels.map(niveau => niveauCounts[niveau]);

            const options: EChartsOption = {
                title: {
                    text: "Répartition des bénéficiaires par niveau de diplôme",
                    left: 'center',
                    top: 20,
                    textStyle: {
                        color: '#262c5e',
                        fontFamily: 'Comfortaa, cursive'
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                xAxis: {
                    type: 'category',
                    data: labels,
                    axisLabel: {
                        rotate: 45,
                        overflow: 'break'
                    }
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: data,
                    type: 'bar',
                    barWidth: '40%',
                    itemStyle: {
                        color: '#FFC744'
                    },
                    label: {
                        show: true,
                        position: 'top'
                    }
                }]
            };

            chart.setOption(options);
            chart.resize();

            setTimeout(() => {
                const base64Image = chart.getDataURL({
                    type: 'png',
                    pixelRatio: 2,
                    backgroundColor: '#fff',
                });

                chart.dispose();
                document.body.removeChild(hiddenDiv);

                resolve(base64Image);
            }, 200);
        });
    }

    async generateChartImgRepBenefByStatut(): Promise<string> {
        return new Promise((resolve) => {
            const hiddenDiv = document.createElement('div');
            hiddenDiv.style.width = '650px';
            hiddenDiv.style.height = '500px';
            hiddenDiv.style.position = 'absolute';
            hiddenDiv.style.top = '-9999px';
            hiddenDiv.style.left = '-9999px';
            document.body.appendChild(hiddenDiv);

            const chart = echarts.init(hiddenDiv);

            // Étape 1 : Filtrer les prestations de type QD
            const prestationsQD = this.listPrestation?.filter(p => p.typePrestation === PrestationType.QD) ?? [];

            const statutCounts: Record<string, number> = {};
            let labels = [];
            Object.values(StatutBeneficiaire).forEach(statut => {
                statutCounts[statut] = 0;
                labels.push(statut);
            });

            prestationsQD.forEach(b => {
                if (b.statutBeneficiaire != null) {
                    statutCounts[b.statutBeneficiaire]++;
                }
            });

            // 4. Générer les données
            const data = labels.map(statut => statutCounts[statut]);
            labels = labels.map(code => StatutBeneficiaireString[code])

            const options: EChartsOption = {
                title: {
                    text: "Répartition des bénéficiaires par statut",
                    left: 'center',
                    top: 20,
                    textStyle: {
                        color: '#262c5e',
                        fontFamily: 'Comfortaa, cursive'
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                xAxis: {
                    type: 'category',
                    data: labels,
                    axisLabel: {
                        rotate: 45,
                        overflow: 'break'
                    }
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: data,
                    type: 'bar',
                    barWidth: '40%',
                    itemStyle: {
                        color: '#FFC744'
                    },
                    label: {
                        show: true,
                        position: 'top'
                    }
                }]
            };

            chart.setOption(options);
            chart.resize();

            setTimeout(() => {
                const base64Image = chart.getDataURL({
                    type: 'png',
                    pixelRatio: 2,
                    backgroundColor: '#fff',
                });

                chart.dispose();
                document.body.removeChild(hiddenDiv);

                resolve(base64Image);
            }, 200);
        });
    }

    async generateImageRepByPathology(): Promise<string> {
        return new Promise((resolve) => {
            const hiddenDiv = document.createElement('div');
            hiddenDiv.style.position = 'absolute';
            hiddenDiv.style.width = '650px';
            hiddenDiv.style.height = '400px';
            hiddenDiv.style.left = '-9999px';
            document.body.appendChild(hiddenDiv);

            const chart = echarts.init(hiddenDiv);

            if((this.selectedService != null && this.selectedService.typeHandicap.name.includes('visuel')) 
                || this.selectedTypeHandicap != null && this.selectedTypeHandicap.name.includes('visuel')){
                this.listOptionHandicapPrincipal.push('Basse vision')
                this.listOptionHandicapPrincipal.push('Cécité')
            }else if((this.selectedService != null && this.selectedService.typeHandicap.name.includes('moteur')) 
                || this.selectedTypeHandicap != null && this.selectedTypeHandicap.name.includes('moteur')){
                this.listOptionHandicapPrincipal.push('Lombalgie')
                this.listOptionHandicapPrincipal.push('TMS')
                this.listOptionHandicapPrincipal.push('Rhumatisme')
                this.listOptionHandicapPrincipal.push('Malformation')
                this.listOptionHandicapPrincipal.push('Paralysie')
                this.listOptionHandicapPrincipal.push('AVC')
                this.listOptionHandicapPrincipal.push('Amputation')

                this.listOptionHandicapPrincipal.push('SEP')
                this.listOptionHandicapPrincipal.push('Fibromyalgie')
                this.listOptionHandicapPrincipal.push('Spondyarthrite ankylosante')
                this.listOptionHandicapPrincipal.push('Troubles cardiaques')
                this.listOptionHandicapPrincipal.push('Cancer')
                this.listOptionHandicapPrincipal.push('Maladie de Chrohn')
                this.listOptionHandicapPrincipal.push('Diabete')
                this.listOptionHandicapPrincipal.push('Autres')
            }else if((this.selectedService != null && this.selectedService.typeHandicap.name.includes('TND')) 
                || this.selectedTypeHandicap != null && this.selectedTypeHandicap.name.includes('TND')){
                this.listOptionHandicapPrincipal.push("Troubles cognitifs acquis (traumatisme crânien, avc...)")
                this.listOptionHandicapPrincipal.push("Troubles du déficit de l'attention avec ou sans hyperactivité")
                this.listOptionHandicapPrincipal.push("Troubles du développement intellectuel (dont handicap mental)")
                this.listOptionHandicapPrincipal.push("Troubles du spectre de l'autisme")
                this.listOptionHandicapPrincipal.push("Troubles spécifiques du langage et des apprentissages (DYS)")
                this.listOptionHandicapPrincipal.push("Epilepsie")
                this.listOptionHandicapPrincipal.push("Polyhandicap")
            }

            const options: EChartsOption = {
                title: {
                    text: 'Pathologies les plus rencontrées',
                    left: 'center',
                    top: 20,
                    textStyle: {
                        color: '#262c5e',
                        fontFamily: 'Comfortaa, cursive'
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                },
                series: [
                    {
                        type: 'pie',
                        radius: '55%',
                        center: ['50%', '60%'],
                        data: Object.values(this.listOptionHandicapPrincipal).map(handicapPrincipal => ({
                            name: handicapPrincipal,
                            value: this.listPrestation!.filter(e => e.beneficiaire != null && e.beneficiaire.handicapPrincipal != null && e.beneficiaire.handicapPrincipal == handicapPrincipal).length
                        })),
                        label: {
                            show: true,
                            formatter: '{b}: {c} ({d}%)',
                            fontSize: 14,
                            overflow: 'break'
                        }
                    }
                ]
            };

            chart.setOption(options);
            chart.resize();

            setTimeout(() => {
                const base64Image = chart.getDataURL({
                    type: 'png',
                    pixelRatio: 2,
                    backgroundColor: '#fff',
                });

                // const link = document.createElement('a');
                // link.href = base64Image;
                // link.download = 'rep-heures-par-presc.png';
                // link.click();

                chart.dispose();
                document.body.removeChild(hiddenDiv);

                resolve(base64Image);
            }, 200);
        });
    }

    async generateImageRepPrestAnnule(): Promise<string> {
        return new Promise((resolve) => {
            const hiddenDiv = document.createElement('div');
            hiddenDiv.style.position = 'absolute';
            hiddenDiv.style.width = '650px';
            hiddenDiv.style.height = '400px';
            hiddenDiv.style.left = '-9999px';
            document.body.appendChild(hiddenDiv);
    
            const chart = echarts.init(hiddenDiv);

            console.log(this.listPrestation.filter(e => e.statut == PrestationStatut.ANNULE));
    
            const abandonCounts: Record<string, number> = {};
            Object.values(NatureAbandonAnnulation).forEach(statut => {
                abandonCounts[statut] = 0;
            });
    
            this.listPrestation.forEach(b => {
                if (b.statut === PrestationStatut.ANNULE && b.natureAbandon != null) {
                    abandonCounts[b.natureAbandon]++;
                }
            });
    
            // Construire le tableau de données avec { value, name }
            const data = Object.keys(abandonCounts).map(code => ({
                value: abandonCounts[code],
                name: NatureAbandonString[code] ?? code,
            }));
    
            const options: EChartsOption = {
                title: {
                    text: 'Nature abandon',
                    left: 'center',
                    top: 20,
                    textStyle: {
                        color: '#262c5e',
                        fontFamily: 'Comfortaa, cursive'
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                },
                series: [
                    {
                        name: 'Abandons',
                        type: 'pie',
                        radius: '55%',
                        center: ['50%', '60%'],
                        data,
                        label: {
                            show: true,
                            formatter: '{b}: {c} ({d}%)',
                            fontSize: 14,
                            overflow: 'break'
                        }
                    }
                ]
            };
    
            chart.setOption(options);
            chart.resize();
    
            setTimeout(() => {
                const base64Image = chart.getDataURL({
                    type: 'png',
                    pixelRatio: 2,
                    backgroundColor: '#fff',
                });
    
                // Si le téléchargement est voulu
                // const link = document.createElement('a');
                // link.href = base64Image;
                // link.download = 'nature-abandon.png';
                // link.click();
    
                chart.dispose();
                document.body.removeChild(hiddenDiv);
    
                resolve(base64Image);
            }, 200);
        });
    }

    async generateImageRepPrestAnnuleQD(): Promise<string> {
        return new Promise((resolve) => {
            const hiddenDiv = document.createElement('div');
            hiddenDiv.style.position = 'absolute';
            hiddenDiv.style.width = '650px';
            hiddenDiv.style.height = '400px';
            hiddenDiv.style.left = '-9999px';
            document.body.appendChild(hiddenDiv);
    
            const chart = echarts.init(hiddenDiv);

            const abandonCounts: Record<string, number> = {};
            Object.values(NatureAbandonAnnulation).forEach(statut => {
                abandonCounts[statut] = 0;
            });

            const prestationsQD = this.listPrestation?.filter(p => p.typePrestation === PrestationType.QD) ?? [];
    
            prestationsQD.forEach(b => {
                if (b.statut === PrestationStatut.ANNULE && b.natureAbandon != null) {
                    abandonCounts[b.natureAbandon]++;
                }
            });
    
            // Construire le tableau de données avec { value, name }
            const data = Object.keys(abandonCounts).map(code => ({
                value: abandonCounts[code],
                name: NatureAbandonString[code] ?? code,
            }));
    
            const options: EChartsOption = {
                title: {
                    text: 'Nature abandon QD',
                    left: 'center',
                    top: 20,
                    textStyle: {
                        color: '#262c5e',
                        fontFamily: 'Comfortaa, cursive'
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                },
                series: [
                    {
                        name: 'Abandons',
                        type: 'pie',
                        radius: '55%',
                        center: ['50%', '60%'],
                        data,
                        label: {
                            show: true,
                            formatter: '{b}: {c} ({d}%)',
                            fontSize: 14,
                            overflow: 'break'
                        }
                    }
                ]
            };
    
            chart.setOption(options);
            chart.resize();
    
            setTimeout(() => {
                const base64Image = chart.getDataURL({
                    type: 'png',
                    pixelRatio: 2,
                    backgroundColor: '#fff',
                });
    
                // Si le téléchargement est voulu
                // const link = document.createElement('a');
                // link.href = base64Image;
                // link.download = 'nature-abandon.png';
                // link.click();
    
                chart.dispose();
                document.body.removeChild(hiddenDiv);
    
                resolve(base64Image);
            }, 200);
        });
    }

    async generateImageRepPrestAnnuleAS(): Promise<string> {
        return new Promise((resolve) => {
            const hiddenDiv = document.createElement('div');
            hiddenDiv.style.position = 'absolute';
            hiddenDiv.style.width = '650px';
            hiddenDiv.style.height = '400px';
            hiddenDiv.style.left = '-9999px';
            document.body.appendChild(hiddenDiv);
    
            const chart = echarts.init(hiddenDiv);

            const abandonCounts: Record<string, number> = {};
            Object.values(NatureAbandonAnnulation).forEach(statut => {
                abandonCounts[statut] = 0;
            });

            const prestationsAS = this.listPrestation?.filter(p => p.typePrestation === PrestationType.AS) ?? [];
    
            prestationsAS.forEach(b => {
                if (b.statut === PrestationStatut.ANNULE && b.natureAbandon != null) {
                    abandonCounts[b.natureAbandon]++;
                }
            });
    
            // Construire le tableau de données avec { value, name }
            const data = Object.keys(abandonCounts).map(code => ({
                value: abandonCounts[code],
                name: NatureAbandonString[code] ?? code,
            }));
    
            const options: EChartsOption = {
                title: {
                    text: 'Nature abandon AS',
                    left: 'center',
                    top: 20,
                    textStyle: {
                        color: '#262c5e',
                        fontFamily: 'Comfortaa, cursive'
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                },
                series: [
                    {
                        name: 'Abandons',
                        type: 'pie',
                        radius: '55%',
                        center: ['50%', '60%'],
                        data,
                        label: {
                            show: true,
                            formatter: '{b}: {c} ({d}%)',
                            fontSize: 14,
                            overflow: 'break'
                        }
                    }
                ]
            };
    
            chart.setOption(options);
            chart.resize();
    
            setTimeout(() => {
                const base64Image = chart.getDataURL({
                    type: 'png',
                    pixelRatio: 2,
                    backgroundColor: '#fff',
                });
    
                // Si le téléchargement est voulu
                // const link = document.createElement('a');
                // link.href = base64Image;
                // link.download = 'nature-abandon.png';
                // link.click();
    
                chart.dispose();
                document.body.removeChild(hiddenDiv);
    
                resolve(base64Image);
            }, 200);
        });
    }

    async generateImageRepPrestAnnuleAC(): Promise<string> {
        return new Promise((resolve) => {
            const hiddenDiv = document.createElement('div');
            hiddenDiv.style.position = 'absolute';
            hiddenDiv.style.width = '650px';
            hiddenDiv.style.height = '400px';
            hiddenDiv.style.left = '-9999px';
            document.body.appendChild(hiddenDiv);
    
            const chart = echarts.init(hiddenDiv);

            const abandonCounts: Record<string, number> = {};
            Object.values(NatureAbandonAnnulation).forEach(statut => {
                abandonCounts[statut] = 0;
            });

            const prestationsAC = this.listPrestation?.filter(p => p.typePrestation === PrestationType.AC) ?? [];
    
            prestationsAC.forEach(b => {
                if (b.statut === PrestationStatut.ANNULE && b.natureAbandon != null) {
                    abandonCounts[b.natureAbandon]++;
                }
            });
    
            // Construire le tableau de données avec { value, name }
            const data = Object.keys(abandonCounts).map(code => ({
                value: abandonCounts[code],
                name: NatureAbandonString[code] ?? code,
            }));
    
            const options: EChartsOption = {
                title: {
                    text: 'Nature abandon AC',
                    left: 'center',
                    top: 20,
                    textStyle: {
                        color: '#262c5e',
                        fontFamily: 'Comfortaa, cursive'
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                },
                series: [
                    {
                        name: 'Abandons',
                        type: 'pie',
                        radius: '55%',
                        center: ['50%', '60%'],
                        data,
                        label: {
                            show: true,
                            formatter: '{b}: {c} ({d}%)',
                            fontSize: 14,
                            overflow: 'break'
                        }
                    }
                ]
            };
    
            chart.setOption(options);
            chart.resize();
    
            setTimeout(() => {
                const base64Image = chart.getDataURL({
                    type: 'png',
                    pixelRatio: 2,
                    backgroundColor: '#fff',
                });
    
                // Si le téléchargement est voulu
                // const link = document.createElement('a');
                // link.href = base64Image;
                // link.download = 'nature-abandon.png';
                // link.click();
    
                chart.dispose();
                document.body.removeChild(hiddenDiv);
    
                resolve(base64Image);
            }, 200);
        });
    }

    async generateImageRepPrestAnnuleCAMEO(): Promise<string> {
        return new Promise((resolve) => {
            const hiddenDiv = document.createElement('div');
            hiddenDiv.style.position = 'absolute';
            hiddenDiv.style.width = '650px';
            hiddenDiv.style.height = '400px';
            hiddenDiv.style.left = '-9999px';
            document.body.appendChild(hiddenDiv);
    
            const chart = echarts.init(hiddenDiv);

            const abandonCounts: Record<string, number> = {};
            Object.values(NatureAbandonAnnulation).forEach(statut => {
                abandonCounts[statut] = 0;
            });

            const prestationsCAMEO = this.listPrestation?.filter(p => p.typePrestation === PrestationType.CAMEO) ?? [];
    
            prestationsCAMEO.forEach(b => {
                if (b.statut === PrestationStatut.ANNULE && b.natureAbandon != null) {
                    abandonCounts[b.natureAbandon]++;
                }
            });
    
            // Construire le tableau de données avec { value, name }
            const data = Object.keys(abandonCounts).map(code => ({
                value: abandonCounts[code],
                name: NatureAbandonString[code] ?? code,
            }));
    
            const options: EChartsOption = {
                title: {
                    text: 'Nature abandon CAMEO',
                    left: 'center',
                    top: 20,
                    textStyle: {
                        color: '#262c5e',
                        fontFamily: 'Comfortaa, cursive'
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                },
                series: [
                    {
                        name: 'Abandons',
                        type: 'pie',
                        radius: '55%',
                        center: ['50%', '60%'],
                        data,
                        label: {
                            show: true,
                            formatter: '{b}: {c} ({d}%)',
                            fontSize: 14,
                            overflow: 'break'
                        }
                    }
                ]
            };
    
            chart.setOption(options);
            chart.resize();
    
            setTimeout(() => {
                const base64Image = chart.getDataURL({
                    type: 'png',
                    pixelRatio: 2,
                    backgroundColor: '#fff',
                });
    
                // Si le téléchargement est voulu
                // const link = document.createElement('a');
                // link.href = base64Image;
                // link.download = 'nature-abandon.png';
                // link.click();
    
                chart.dispose();
                document.body.removeChild(hiddenDiv);
    
                resolve(base64Image);
            }, 200);
        });
    }

    async generateImageRepPrestAnnuleSP(): Promise<string> {
        return new Promise((resolve) => {
            const hiddenDiv = document.createElement('div');
            hiddenDiv.style.position = 'absolute';
            hiddenDiv.style.width = '650px';
            hiddenDiv.style.height = '400px';
            hiddenDiv.style.left = '-9999px';
            document.body.appendChild(hiddenDiv);
    
            const chart = echarts.init(hiddenDiv);

            const abandonCounts: Record<string, number> = {};
            Object.values(NatureAbandonAnnulation).forEach(statut => {
                abandonCounts[statut] = 0;
            });

            const prestationsSP = this.listPrestation?.filter(p => p.typePrestation === PrestationType.SP) ?? [];
    
            prestationsSP.forEach(b => {
                if (b.statut === PrestationStatut.ANNULE && b.natureAbandon != null) {
                    abandonCounts[b.natureAbandon]++;
                }
            });
    
            // Construire le tableau de données avec { value, name }
            const data = Object.keys(abandonCounts).map(code => ({
                value: abandonCounts[code],
                name: NatureAbandonString[code] ?? code,
            }));
    
            const options: EChartsOption = {
                title: {
                    text: 'Nature abandon SP',
                    left: 'center',
                    top: 20,
                    textStyle: {
                        color: '#262c5e',
                        fontFamily: 'Comfortaa, cursive'
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                },
                series: [
                    {
                        name: 'Abandons',
                        type: 'pie',
                        radius: '55%',
                        center: ['50%', '60%'],
                        data,
                        label: {
                            show: true,
                            formatter: '{b}: {c} ({d}%)',
                            fontSize: 14,
                            overflow: 'break'
                        }
                    }
                ]
            };
    
            chart.setOption(options);
            chart.resize();
    
            setTimeout(() => {
                const base64Image = chart.getDataURL({
                    type: 'png',
                    pixelRatio: 2,
                    backgroundColor: '#fff',
                });
    
                // Si le téléchargement est voulu
                // const link = document.createElement('a');
                // link.href = base64Image;
                // link.download = 'nature-abandon.png';
                // link.click();
    
                chart.dispose();
                document.body.removeChild(hiddenDiv);
    
                resolve(base64Image);
            }, 200);
        });
    }

    async generateImageRepPrestAnnuleEAP(): Promise<string> {
        return new Promise((resolve) => {
            const hiddenDiv = document.createElement('div');
            hiddenDiv.style.position = 'absolute';
            hiddenDiv.style.width = '650px';
            hiddenDiv.style.height = '400px';
            hiddenDiv.style.left = '-9999px';
            document.body.appendChild(hiddenDiv);
    
            const chart = echarts.init(hiddenDiv);

            const abandonCounts: Record<string, number> = {};
            Object.values(NatureAbandonAnnulation).forEach(statut => {
                abandonCounts[statut] = 0;
            });

            const prestationsEAP = this.listPrestation?.filter(p => p.typePrestation === PrestationType.EAP) ?? [];
    
            prestationsEAP.forEach(b => {
                if (b.statut === PrestationStatut.ANNULE && b.natureAbandon != null) {
                    abandonCounts[b.natureAbandon]++;
                }
            });
    
            // Construire le tableau de données avec { value, name }
            const data = Object.keys(abandonCounts).map(code => ({
                value: abandonCounts[code],
                name: NatureAbandonString[code] ?? code,
            }));
    
            const options: EChartsOption = {
                title: {
                    text: 'Nature abandon EAP',
                    left: 'center',
                    top: 20,
                    textStyle: {
                        color: '#262c5e',
                        fontFamily: 'Comfortaa, cursive'
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                },
                series: [
                    {
                        name: 'Abandons',
                        type: 'pie',
                        radius: '55%',
                        center: ['50%', '60%'],
                        data,
                        label: {
                            show: true,
                            formatter: '{b}: {c} ({d}%)',
                            fontSize: 14,
                            overflow: 'break'
                        }
                    }
                ]
            };
    
            chart.setOption(options);
            chart.resize();
    
            setTimeout(() => {
                const base64Image = chart.getDataURL({
                    type: 'png',
                    pixelRatio: 2,
                    backgroundColor: '#fff',
                });
    
                // Si le téléchargement est voulu
                // const link = document.createElement('a');
                // link.href = base64Image;
                // link.download = 'nature-abandon.png';
                // link.click();
    
                chart.dispose();
                document.body.removeChild(hiddenDiv);
    
                resolve(base64Image);
            }, 200);
        });
    }

    async generateChartImgRepPrestByDpt(): Promise<string> {
        return new Promise((resolve) => {
            const hiddenDiv = document.createElement('div');
            hiddenDiv.style.width = '650px';
            hiddenDiv.style.height = '400px';
            hiddenDiv.style.position = 'absolute';
            hiddenDiv.style.top = '-9999px';
            hiddenDiv.style.left = '-9999px';
            document.body.appendChild(hiddenDiv);

            const chart = echarts.init(hiddenDiv);

            const options: EChartsOption = {
                title: {
                    text: 'Répartition des prestations en fonction des départements',
                    left: 'center',
                    top: 20,
                    textStyle: {
                        color: '#262c5e',
                        fontFamily: 'Comfortaa, cursive'
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                },
                series: [
                    {
                        type: 'pie',
                        radius: '55%',
                        center: ['50%', '60%'],
                        data: this.selectedDepartement.map(p => ({
                            name: p.name + "(" + p.code + ")",
                            value: this.listPrestation!.filter(e => e.typePrestation != PrestationType.QD &&
                                e.beneficiaire != null && e.beneficiaire.departement != null && e.beneficiaire.departement?.id == p.id).length
                        })),
                        label: {
                            show: true,
                            formatter: '{b}: {c} ({d}%)',
                            fontSize: 14,
                            overflow: 'break'
                        }
                    }
                ]
            };

            chart.setOption(options);
            chart.resize();

            setTimeout(() => {
                const base64Image = chart.getDataURL({
                    type: 'png',
                    pixelRatio: 2,
                    backgroundColor: '#fff',
                });

                chart.dispose();
                document.body.removeChild(hiddenDiv);

                resolve(base64Image);
            }, 200);
        });
    }

    async generateChartImgRepPrestByDptByPrescripteur(): Promise<string[]> {
        const base64Images: string[] = [];
    
        for (const dpt of this.selectedDepartement) {
            // 1. Filtrer les prestations du département (hors QD)
            const prestations = this.listPrestation?.filter(p =>
                p.typePrestation !== PrestationType.QD &&
                p.beneficiaire?.departement?.id === dpt.id
            ) ?? [];
    
            // Si aucune prestation, on saute ce département
            if (prestations.length === 0) {
                continue;
            }
    
            // 2. Créer le conteneur du graphique
            const hiddenDiv = document.createElement('div');
            hiddenDiv.style.width = '700px';
            hiddenDiv.style.height = '600px';
            hiddenDiv.style.position = 'absolute';
            hiddenDiv.style.top = '-9999px';
            hiddenDiv.style.left = '-9999px';
            document.body.appendChild(hiddenDiv);
    
            const chart = echarts.init(hiddenDiv);
    
            // 3. Construire la liste des prescripteurs (typeStructure.name)
            const prescripteurSet = new Set<string>();
            prestations.forEach(p => {
                const name = p.prescripteur?.typeStructure?.name;
                if (name) prescripteurSet.add(name);
            });
            const labels = Array.from(prescripteurSet);
    
            // 4. Compter le nombre de prestations par prescripteur
            const prescripteurCounts: Record<string, number> = {};
            labels.forEach(name => prescripteurCounts[name] = 0);
    
            prestations.forEach(p => {
                const name = p.prescripteur?.typeStructure?.name;
                if (name) prescripteurCounts[name]++;
            });
    
            const data = labels.map(name => prescripteurCounts[name]);
    
            // 5. Définir l'option ECharts
            const options: EChartsOption = {
                title: {
                    text: `Répartition des prestations par prescripteur - ${dpt.name} (${dpt.code})`,
                    left: 'center',
                    top: 20,
                    textStyle: {
                        color: '#262c5e',
                        fontFamily: 'Comfortaa, cursive'
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                xAxis: {
                    type: 'category',
                    data: labels,
                    axisLabel: {
                        rotate: 45,
                        overflow: 'break'
                    }
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: data,
                    type: 'bar',
                    barWidth: '40%',
                    itemStyle: {
                        color: '#FFC744'
                    },
                    label: {
                        show: true,
                        position: 'top'
                    }
                }]
            };
    
            chart.setOption(options);
            chart.resize();
    
            // 6. Attendre le rendu et récupérer l’image
            const base64Image = await new Promise<string>(resolve => {
                setTimeout(() => {
                    const image = chart.getDataURL({
                        type: 'png',
                        pixelRatio: 2,
                        backgroundColor: '#fff',
                    });
    
                    chart.dispose();
                    document.body.removeChild(hiddenDiv);
                    resolve(image);
                }, 300);
            });
    
            base64Images.push(base64Image);
        }
    
        return base64Images;
    }

    async generateChartImgRepHeuresByDpt(): Promise<string> {
        const hiddenDiv = document.createElement('div');
        hiddenDiv.style.width = '650px';
        hiddenDiv.style.height = '400px';
        hiddenDiv.style.position = 'absolute';
        hiddenDiv.style.top = '-9999px';
        hiddenDiv.style.left = '-9999px';
        document.body.appendChild(hiddenDiv);

        const chart = echarts.init(hiddenDiv);

        const departements = this.selectedDepartement;

        // Tableau de Promises pour chaque département
        const dataPromises = departements.map(async (dpt) => {
            // Filtrer les prestations du département, exclure QD
            const prestations = this.listPrestation!.filter(p =>
                p.typePrestation !== PrestationType.QD &&
                p.beneficiaire?.departement?.id === dpt.id
            );

            

            let totalHeures = 0;

            // Récupérer les activités et additionner les heures
            const heuresPromises = prestations.map(p =>
                this.facade.activitePrestationService.getByPrestation(p.id).toPromise()
            );

            const allActivites = await Promise.all(heuresPromises);

            allActivites.forEach((activites) => {
                activites?.forEach((a: ActivitePrestation) => {
                    totalHeures += a.chargeTravail ?? 0;
                });
            });

            return {
                name: `${dpt.name} (${dpt.code})`,
                value: totalHeures
            };
        });

        const data = await Promise.all(dataPromises);

        const options: EChartsOption = {
            title: {
                text: 'Répartition des heures réalisées par département',
                left: 'center',
                top: 20,
                textStyle: {
                    color: '#262c5e',
                    fontFamily: 'Comfortaa, cursive'
                }
            },
            tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b} : {c}h ({d}%)'
            },
            series: [
                {
                    name: 'Heures par département',
                    type: 'pie',
                    radius: '55%',
                    center: ['50%', '60%'],
                    data: data,
                    label: {
                        show: true,
                        formatter: '{b}: {c}h ({d}%)',
                        fontSize: 14,
                        overflow: 'break'
                    }
                }
            ]
        };

        chart.setOption(options);
        chart.resize();

        return new Promise((resolve) => {
            setTimeout(() => {
                const base64Image = chart.getDataURL({
                    type: 'png',
                    pixelRatio: 2,
                    backgroundColor: '#fff',
                });

                chart.dispose();
                document.body.removeChild(hiddenDiv);

                resolve(base64Image);
            }, 300); // attendre le rendu
        });
    }

    async generateChartImgRepPrestEnFctPresc(): Promise<string> {
        return new Promise((resolve) => {
            const hiddenDiv = document.createElement('div');
            hiddenDiv.style.width = '700px';
            hiddenDiv.style.height = '600px';
            hiddenDiv.style.position = 'absolute';
            hiddenDiv.style.top = '-9999px';
            hiddenDiv.style.left = '-9999px';
            document.body.appendChild(hiddenDiv);

            const chart = echarts.init(hiddenDiv);

            // Étape 1 : Filtrer les prestations de type QD
            const prestations = this.listPrestation?.filter(p => p.typePrestation != PrestationType.QD) ?? [];
            prestations.forEach(b => {
                if (b.prescripteur != null && b.prescripteur.typeStructure != null && !this.prescripteurList.includes(b.prescripteur.typeStructure.name)) {
                    this.prescripteurList.push(b.prescripteur.typeStructure.name);
                }
            });

            const prescripteurCounts: Record<string, number> = {};
            let labels = [];
            this.prescripteurList.forEach(name => {
                prescripteurCounts[name] = 0;
                labels.push(name);
            });

            prestations.forEach(b => {
                if (b.prescripteur != null && b.prescripteur.typeStructure != null) {
                    prescripteurCounts[b.prescripteur.typeStructure.name]++;
                }
            });

            const data = labels.map(statut => prescripteurCounts[statut]);

            const options: EChartsOption = {
                title: {
                    text: "Répartition des prestations réalisées en fonction des prescripteurs",
                    left: 'center',
                    top: 20,
                    textStyle: {
                        color: '#262c5e',
                        fontFamily: 'Comfortaa, cursive'
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                xAxis: {
                    type: 'category',
                    data: labels,
                    axisLabel: {
                        rotate: 45,
                        overflow: 'break'
                    }
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: data,
                    type: 'bar',
                    barWidth: '40%',
                    itemStyle: {
                        color: '#FFC744'
                    },
                    label: {
                        show: true,
                        position: 'top'
                    }
                }]
            };

            chart.setOption(options);
            chart.resize();

            setTimeout(() => {
                const base64Image = chart.getDataURL({
                    type: 'png',
                    pixelRatio: 2,
                    backgroundColor: '#fff',
                });

                chart.dispose();
                document.body.removeChild(hiddenDiv);

                resolve(base64Image);
            }, 200);
        });
    }

    async generateChartImgRepHeuresEnFctPresc(): Promise<string> {
        const hiddenDiv = document.createElement('div');
        hiddenDiv.style.width = '650px';
        hiddenDiv.style.height = '400px';
        hiddenDiv.style.position = 'absolute';
        hiddenDiv.style.top = '-9999px';
        hiddenDiv.style.left = '-9999px';
        document.body.appendChild(hiddenDiv);

        const chart = echarts.init(hiddenDiv);

        const prescripteurs = this.prescripteurList;

        // Tableau de Promises pour chaque département
        const dataPromises = prescripteurs.map(async (presc) => {
            // Filtrer les prestations du département, exclure QD
            const prestations = this.listPrestation!.filter(p =>
                p.typePrestation !== PrestationType.QD &&
                p.prescripteur?.typeStructure?.name === presc
            );

            let totalHeures = 0;

            // Récupérer les activités et additionner les heures
            const heuresPromises = prestations.map(p =>
                this.facade.activitePrestationService.getByPrestation(p.id).toPromise()
            );

            const allActivites = await Promise.all(heuresPromises);

            allActivites.forEach((activites) => {
                activites?.forEach((a: ActivitePrestation) => {
                    totalHeures += a.chargeTravail ?? 0;
                });
            });

            return {
                name: `${presc}`,
                value: totalHeures
            };
        });

        const data = await Promise.all(dataPromises);

        const options: EChartsOption = {
            title: {
                text: 'Répartition des heures réalisées en fonction des prescripteurs',
                left: 'center',
                top: 20,
                textStyle: {
                    color: '#262c5e',
                    fontFamily: 'Comfortaa, cursive'
                }
            },
            tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b} : {c}h ({d}%)'
            },
            series: [
                {
                    type: 'pie',
                    radius: '55%',
                    center: ['50%', '60%'],
                    data: data,
                    label: {
                        show: true,
                        formatter: '{b}: {c}h ({d}%)',
                        fontSize: 14,
                        overflow: 'break'
                    }
                }
            ]
        };

        chart.setOption(options);
        chart.resize();

        return new Promise((resolve) => {
            setTimeout(() => {
                const base64Image = chart.getDataURL({
                    type: 'png',
                    pixelRatio: 2,
                    backgroundColor: '#fff',
                });

                chart.dispose();
                document.body.removeChild(hiddenDiv);

                resolve(base64Image);
            }, 300); // attendre le rendu
        });
    }

    async generateChartImgRepPrestations(): Promise<string> {
        return new Promise((resolve) => {
            const hiddenDiv = document.createElement('div');
            hiddenDiv.style.width = '700px';
            hiddenDiv.style.height = '600px';
            hiddenDiv.style.position = 'absolute';
            hiddenDiv.style.top = '-9999px';
            hiddenDiv.style.left = '-9999px';
            document.body.appendChild(hiddenDiv);

            const chart = echarts.init(hiddenDiv);

            const prestations = this.listPrestation?.filter(p => p.typePrestation != PrestationType.QD) ?? [];

            const prestationCounts: Record<string, number> = {};
            let labels = [];
            Object.values(ModuleType).forEach(nd => {
                prestationCounts[nd] = 0;
                labels.push(nd);
            });

            prestations.forEach(b => {
                if (b.typePrestation != null) {
                    prestationCounts[b.typePrestation]++;
                }
            });

            const data = labels.map(prestation => prestationCounts[prestation]);

            const options: EChartsOption = {
                title: {
                    text: "Nombre de prestations réalisées",
                    left: 'center',
                    top: 20,
                    textStyle: {
                        color: '#262c5e',
                        fontFamily: 'Comfortaa, cursive'
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                xAxis: {
                    type: 'category',
                    data: labels,
                    axisLabel: {
                        rotate: 45,
                        overflow: 'break'
                    }
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: data,
                    type: 'bar',
                    barWidth: '40%',
                    itemStyle: {
                        color: '#FFC744'
                    },
                    label: {
                        show: true,
                        position: 'top'
                    }
                }]
            };

            chart.setOption(options);
            chart.resize();

            setTimeout(() => {
                const base64Image = chart.getDataURL({
                    type: 'png',
                    pixelRatio: 2,
                    backgroundColor: '#fff',
                });

                // const link = document.createElement('a');
                // link.href = base64Image;
                // link.download = 'rep-heures-par-presc.png';
                // link.click();

                chart.dispose();
                document.body.removeChild(hiddenDiv);

                resolve(base64Image);
            }, 200);
        });
    }

    async generateChartImgRepHeuresEnFctPrest(): Promise<string> {
        const hiddenDiv = document.createElement('div');
        hiddenDiv.style.width = '650px';
        hiddenDiv.style.height = '400px';
        hiddenDiv.style.position = 'absolute';
        hiddenDiv.style.top = '-9999px';
        hiddenDiv.style.left = '-9999px';
        document.body.appendChild(hiddenDiv);

        const chart = echarts.init(hiddenDiv);

        // Tableau de Promises pour chaque département
        const dataPromises = Object.values(ModuleType).map(async (typeModule) => {
            // Filtrer les prestations du département, exclure QD
            const prestations = this.listPrestation!.filter(p =>
                p.typePrestation !== PrestationType.QD &&
                p.typePrestation === typeModule
            );

            let totalHeures = 0;

            // Récupérer les activités et additionner les heures
            const heuresPromises = prestations.map(p =>
                this.facade.activitePrestationService.getByPrestation(p.id).toPromise()
            );

            const allActivites = await Promise.all(heuresPromises);

            allActivites.forEach((activites) => {
                activites?.forEach((a: ActivitePrestation) => {
                    totalHeures += a.chargeTravail ?? 0;
                });
            });

            return {
                name: `${typeModule}`,
                value: totalHeures
            };
        });

        const data = await Promise.all(dataPromises);

        const options: EChartsOption = {
            title: {
                text: 'Répartition des heures réalisées en fonction des prestations',
                left: 'center',
                top: 20,
                textStyle: {
                    color: '#262c5e',
                    fontFamily: 'Comfortaa, cursive'
                }
            },
            tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b} : {c}h ({d}%)'
            },
            series: [
                {
                    type: 'pie',
                    radius: '55%',
                    center: ['50%', '60%'],
                    data: data,
                    label: {
                        show: true,
                        formatter: '{b}: {c}h ({d}%)',
                        fontSize: 14,
                        overflow: 'break'
                    }
                }
            ]
        };

        chart.setOption(options);
        chart.resize();

        return new Promise((resolve) => {
            setTimeout(() => {
                const base64Image = chart.getDataURL({
                    type: 'png',
                    pixelRatio: 2,
                    backgroundColor: '#fff',
                });

                // const link = document.createElement('a');
                // link.href = base64Image;
                // link.download = 'rep-heures-par-presc.png';
                // link.click();

                chart.dispose();
                document.body.removeChild(hiddenDiv);

                resolve(base64Image);
            }, 300); // attendre le rendu
        });
    }

	async generateChartImgRepRestitutionAides(): Promise<string> {
        return new Promise(async (resolve) => {
            const hiddenDiv = document.createElement('div');
            hiddenDiv.style.width = '700px';
            hiddenDiv.style.height = '600px';
            hiddenDiv.style.position = 'absolute';
            hiddenDiv.style.top = '-9999px';
            hiddenDiv.style.left = '-9999px';
            document.body.appendChild(hiddenDiv);

            const chart = echarts.init(hiddenDiv);

            const allRestitutions = await Promise.all(
                this.listPrestation.map(async prest => {
                    const restitutions = await firstValueFrom(
                        this.facade.restitutionPrestationService.getByPrestation(prest.id)
                    );
                    return restitutions.length > 0 ? [restitutions[restitutions.length -1]] : [];
                })
            );
		
			this.restitutions = allRestitutions.flat();

			const restitutionCounts: Record<string, number> = {};
            let labels = [];
            Object.values(AideTypeStringEnum).forEach(nd => {
                restitutionCounts[nd] = 0;
                labels.push(nd);
            });

            this.restitutions.forEach(b => {
                if (b.reponsesIdentifiees.includes(AideType.AH)) {
                    restitutionCounts[AideTypeStringEnum.AH]++;
                }
				if (b.reponsesIdentifiees.includes(AideType.AO)) {
                    restitutionCounts[AideTypeStringEnum.AO]++;
                }
				if (b.reponsesIdentifiees.includes(AideType.AT)) {
                    restitutionCounts[AideTypeStringEnum.AT]++;
                }
				if (b.reponsesIdentifiees.includes(AideType.MED)) {
                    restitutionCounts[AideTypeStringEnum.MED]++;
                }
            });

            const data = labels.map(restitution => restitutionCounts[restitution]);

            const options: EChartsOption = {
                title: {
                    text: "Restitutions",
                    left: 'center',
                    top: 20,
                    textStyle: {
                        color: '#262c5e',
                        fontFamily: 'Comfortaa, cursive'
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                xAxis: {
                    type: 'category',
                    data: labels,
                    axisLabel: {
                        rotate: 45,
                        overflow: 'break'
                    }
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: data,
                    type: 'bar',
                    barWidth: '40%',
                    itemStyle: {
                        color: '#FFC744'
                    },
                    label: {
                        show: true,
                        position: 'top'
                    }
                }]
            };

            chart.setOption(options);
            chart.resize();

            setTimeout(() => {
                const base64Image = chart.getDataURL({
                    type: 'png',
                    pixelRatio: 2,
                    backgroundColor: '#fff',
                });

                // const link = document.createElement('a');
                // link.href = base64Image;
                // link.download = 'rep-heures-par-presc.png';
                // link.click();

                chart.dispose();
                document.body.removeChild(hiddenDiv);

                resolve(base64Image);
            }, 200);
        });
    }

	async generateChartImgRepSuiviPrecoMeoSolution(): Promise<string> {
        return new Promise(async (resolve) => {
            const hiddenDiv = document.createElement('div');
            hiddenDiv.style.width = '700px';
            hiddenDiv.style.height = '600px';
            hiddenDiv.style.position = 'absolute';
            hiddenDiv.style.top = '-9999px';
            hiddenDiv.style.left = '-9999px';
            document.body.appendChild(hiddenDiv);

            const chart = echarts.init(hiddenDiv);

			const prestationsSP = this.listPrestation?.filter(p => p.typePrestation === PrestationType.SP) ?? [];

			const spMeoCounts: Record<string, number> = {};
            let labels = ["Oui", "Oui partiellement", "Non"];

            labels.forEach(nd => {
                spMeoCounts[nd] = 0;
            });

            prestationsSP.forEach(b => {
                if (b.meoSolutions == "oui") {
                    spMeoCounts["Oui"]++;
                }
				else if (b.meoSolutions == "ouiPartiellement") {
                    spMeoCounts["Oui partiellement"]++;
                }
				else if (b.meoSolutions == "non") {
                    spMeoCounts["Non"]++;
                }
            });

            const data = labels.map(sp => spMeoCounts[sp]);

            const options: EChartsOption = {
                title: {
                    text: "SP - Mise en oeuvre des solutions de compensation préconisées",
                    left: 'center',
                    top: 20,
                    textStyle: {
                        color: '#262c5e',
                        fontFamily: 'Comfortaa, cursive'
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                xAxis: {
                    type: 'category',
                    data: labels,
                    axisLabel: {
                        rotate: 45,
                        overflow: 'break'
                    }
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: data,
                    type: 'bar',
                    barWidth: '40%',
                    itemStyle: {
                        color: '#FFC744'
                    },
                    label: {
                        show: true,
                        position: 'top'
                    }
                }]
            };

            chart.setOption(options);
            chart.resize();

            setTimeout(() => {
                const base64Image = chart.getDataURL({
                    type: 'png',
                    pixelRatio: 2,
                    backgroundColor: '#fff',
                });

                // const link = document.createElement('a');
                // link.href = base64Image;
                // link.download = 'rep-heures-par-presc.png';
                // link.click();

                chart.dispose();
                document.body.removeChild(hiddenDiv);

                resolve(base64Image);
            }, 200);
        });
    }

	async generateChartImgRepSuiviPrecoNouvelAS(): Promise<string> {
        return new Promise(async (resolve) => {
            const hiddenDiv = document.createElement('div');
            hiddenDiv.style.width = '700px';
            hiddenDiv.style.height = '600px';
            hiddenDiv.style.position = 'absolute';
            hiddenDiv.style.top = '-9999px';
            hiddenDiv.style.left = '-9999px';
            document.body.appendChild(hiddenDiv);

            const chart = echarts.init(hiddenDiv);

			const prestationsSP = this.listPrestation?.filter(p => p.typePrestation === PrestationType.SP) ?? [];

			const spMeoCounts: Record<string, number> = {};
            let labels = ["Oui", "Non"];

            labels.forEach(nd => {
                spMeoCounts[nd] = 0;
            });

            prestationsSP.forEach(b => {
                if (b.propositionAs === true) {
                    spMeoCounts["Oui"]++;
                }
				else if (b.propositionAs === false) {
                    spMeoCounts["Non"]++;
                }
            });

            const data = labels.map(sp => spMeoCounts[sp]);

            const options: EChartsOption = {
                title: {
                    text: "SP - Proposition au prescripteur d'un nouvel appui spécifique",
                    left: 'center',
                    top: 20,
                    textStyle: {
                        color: '#262c5e',
                        fontFamily: 'Comfortaa, cursive'
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                xAxis: {
                    type: 'category',
                    data: labels,
                    axisLabel: {
                        rotate: 45,
                        overflow: 'break'
                    }
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: data,
                    type: 'bar',
                    barWidth: '40%',
                    itemStyle: {
                        color: '#FFC744'
                    },
                    label: {
                        show: true,
                        position: 'top'
                    }
                }]
            };

            chart.setOption(options);
            chart.resize();

            setTimeout(() => {
                const base64Image = chart.getDataURL({
                    type: 'png',
                    pixelRatio: 2,
                    backgroundColor: '#fff',
                });

                // const link = document.createElement('a');
                // link.href = base64Image;
                // link.download = 'rep-heures-par-presc.png';
                // link.click();

                chart.dispose();
                document.body.removeChild(hiddenDiv);

                resolve(base64Image);
            }, 200);
        });
    }

	async generateChartImgRepSuiviPrecoAutreDispositif(): Promise<string> {
        return new Promise(async (resolve) => {
            const hiddenDiv = document.createElement('div');
            hiddenDiv.style.width = '700px';
            hiddenDiv.style.height = '600px';
            hiddenDiv.style.position = 'absolute';
            hiddenDiv.style.top = '-9999px';
            hiddenDiv.style.left = '-9999px';
            document.body.appendChild(hiddenDiv);

            const chart = echarts.init(hiddenDiv);

			const prestationsSP = this.listPrestation?.filter(p => p.typePrestation === PrestationType.SP) ?? [];

			const spMeoCounts: Record<string, number> = {};
            let labels = ["Oui", "Non"];

            labels.forEach(nd => {
                spMeoCounts[nd] = 0;
            });

            prestationsSP.forEach(b => {
                if (b.propositionAutre === true) {
                    spMeoCounts["Oui"]++;
                }
				else if (b.propositionAutre === false) {
                    spMeoCounts["Non"]++;
                }
            });

            const data = labels.map(sp => spMeoCounts[sp]);

            const options: EChartsOption = {
                title: {
                    text: "SP - Proposition au prescripteur d'une orientation vers un autre dispositif",
                    left: 'center',
                    top: 20,
                    textStyle: {
                        color: '#262c5e',
                        fontFamily: 'Comfortaa, cursive'
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                xAxis: {
                    type: 'category',
                    data: labels,
                    axisLabel: {
                        rotate: 45,
                        overflow: 'break'
                    }
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: data,
                    type: 'bar',
                    barWidth: '40%',
                    itemStyle: {
                        color: '#FFC744'
                    },
                    label: {
                        show: true,
                        position: 'top'
                    }
                }]
            };

            chart.setOption(options);
            chart.resize();

            setTimeout(() => {
                const base64Image = chart.getDataURL({
                    type: 'png',
                    pixelRatio: 2,
                    backgroundColor: '#fff',
                });

                // const link = document.createElement('a');
                // link.href = base64Image;
                // link.download = 'rep-heures-par-presc.png';
                // link.click();

                chart.dispose();
                document.body.removeChild(hiddenDiv);

                resolve(base64Image);
            }, 200);
        });
    }

    updateBdcTrackHours(): void {
        this.facade.institutionService
            .updateBdcTrackHours()
            .subscribe({
                next: (a) => {
                    this.toastService.createSuccessToast('');
                },
                error: (err: ErrorResponse) => {
                    this.toastService.createHttpErrorToast(
                        err.error.message,
                        err.status
                    );
                }
            });
    }

    updateServer(): void {
        this.facade.institutionService
            .updateServer()
            .subscribe({
                next: (a) => {
                    this.toastService.createSuccessToast('');
                },
                error: (err: ErrorResponse) => {
                    this.toastService.createHttpErrorToast(
                        err.error.message,
                        err.status
                    );
                }
            });
    }

    generateAndAddToGedSynthesisBdc(): void {
        this.facade.institutionService
            .generateAndAddToGedSynthesisBdc()
            .subscribe({
                next: (a) => {
                    this.toastService.createSuccessToast('');
                },
                error: (err: ErrorResponse) => {
                    this.toastService.createHttpErrorToast(
                        err.error.message,
                        err.status
                    );
                }
            });
    }

    async generateActivityReport(): Promise<void> {
        this.loadingActivityReport = true;
        this.institution.dateDebut = this.systemForm.get('dateDebutRA').value;
        this.institution.dateFin = this.systemForm.get('dateFinRA').value;

        const typeExport = this.systemForm.get('typeExport')?.value;
        this.selectedService = this.listService?.find(x => x.id == this.systemForm.get('service').value); 
        this.selectedRegion = this.listRegion?.find(x => x.id == this.systemForm.get('region').value);
        this.selectedTypeHandicap = this.listTypeHandicap?.find(x => x.id == this.systemForm.get('typeHandicap').value); 
        if(this.selectedRegion != null){
            this.selectedDepartement = this.selectedRegion.departements;
        }

        if(typeExport == TypeExportEnum.TOUT){
            this.listPrestation = await firstValueFrom(
                this.facade.prestationService.getPrestationByDates(this.institution.dateDebut, this.institution.dateFin
                )
            );
        }else if(typeExport == TypeExportEnum.SERVICE){
            this.listPrestation = await firstValueFrom(
                this.facade.prestationService.getPrestationByServiceAndDates(
                    this.selectedService.id, this.institution.dateDebut, this.institution.dateFin
                )
            );
        }else if(typeExport == TypeExportEnum.SERVICEREGION){
            this.listPrestation = await firstValueFrom(
                this.facade.prestationService.getPrestationByServiceAndRegionAndDates(
                    this.selectedService.id, this.selectedRegion.id, this.institution.dateDebut, this.institution.dateFin
                )
            );
        }else if(typeExport == TypeExportEnum.TYPEHANDICAP){
            this.listPrestation = await firstValueFrom(
                this.facade.prestationService.getPrestationByTypeHandicapAndDates(
                    this.selectedTypeHandicap.id, this.institution.dateDebut, this.institution.dateFin
                )
            );
        }

        const imgSrcList: string[] = [];
        imgSrcList.push(await this.generateImageRepPresEnFctPrest());
        imgSrcList.push(await this.generateChartImgRepPrescByDpt());
        imgSrcList.push(await this.generateChartImgNbPrescByMonthBarChart());
        imgSrcList.push(await this.generateChartImgRepBenefBySex());
        imgSrcList.push(await this.generateChartImgRepBenefByAge());
        imgSrcList.push(await this.generateChartImgRepBenefByNiveau());
        imgSrcList.push(await this.generateChartImgRepBenefByStatut());
        imgSrcList.push(await this.generateImageRepByPathology());
        imgSrcList.push(await this.generateImageRepPrestAnnule());
        imgSrcList.push(await this.generateImageRepPrestAnnuleQD());
        imgSrcList.push(await this.generateImageRepPrestAnnuleAS());
        imgSrcList.push(await this.generateImageRepPrestAnnuleAC());
        imgSrcList.push(await this.generateImageRepPrestAnnuleCAMEO());
        imgSrcList.push(await this.generateImageRepPrestAnnuleEAP());
        imgSrcList.push(await this.generateImageRepPrestAnnuleSP());
        imgSrcList.push(await this.generateChartImgRepPrestByDpt());
        imgSrcList.push(await this.generateChartImgRepHeuresByDpt());
        imgSrcList.push(await this.generateChartImgRepPrestEnFctPresc());
        imgSrcList.push(await this.generateChartImgRepHeuresEnFctPresc());
        imgSrcList.push(await this.generateChartImgRepPrestations());
        imgSrcList.push(await this.generateChartImgRepHeuresEnFctPrest());
		imgSrcList.push(await this.generateChartImgRepRestitutionAides());
		imgSrcList.push(await this.generateChartImgRepSuiviPrecoMeoSolution());
		imgSrcList.push(await this.generateChartImgRepSuiviPrecoNouvelAS());
		imgSrcList.push(await this.generateChartImgRepSuiviPrecoAutreDispositif());
        imgSrcList.push(...await this.generateChartImgRepPrestByDptByPrescripteur());

        if (this.institution.dateDebut && this.institution.dateFin) {
          this.facade.institutionService.downloadActivityReport(typeExport,
            this.selectedService?.id, this.selectedRegion?.id, this.selectedTypeHandicap?.id, this.institution,
            imgSrcList
          ).subscribe((blob) => {
            saveAs(blob, "Rapport d'activité.docx");
            this.loadingActivityReport = false;
          });
        }
    }

    generateReport(): void {
        this.loadingReport = true;
        this.institution.dateDebut = this.systemForm.get('dateDebut').value;
        this.institution.dateFin = this.systemForm.get('dateFin').value;
        this.facade.institutionService.downloadReport(this.facade.dataStorageService.getService()?.id, this.facade.dataStorageService.getRegion()?.id,
            this.institution).subscribe(
                (blob) => {
                    saveAs(blob, "Indicateurs.xlsx")
                    this.loadingReport = false;
                }

            )
    }
    /**
     * Méthode d'envoie de formulaire, si celui est valide stock les données et envoie un signal au composant parent
     */
    submitForm() {
        if (this.systemForm.valid) {
            this.institution.smtpHost = this.systemForm.get('smtpHost').value;
            this.institution.smtpUserName = this.systemForm.get('smtpUserName').value;
            this.institution.smtpPswd = this.systemForm.get('smtpPswd').value;
            this.institution.smtpPort = this.systemForm.get('smtpPort').value;
            this.institution.gedHost = this.systemForm.get('gedHost').value;
            this.institution.gedPswd = this.systemForm.get('gedPswd').value;
            this.institution.gedUsername = this.systemForm.get('gedUsername').value;
            this.institution.gedPort = this.systemForm.get('gedPort').value;

            this.isValidateButtonClicked.value = true;
            this.facade.institutionService
                .updateInstitution(this.institution)
                .subscribe({
                    next: (a) => {
                        this.isValidateButtonClicked.value = false;
                        this.toastService.createSuccessToast('');
                    },
                    error: (err: ErrorResponse) => {
                        this.isValidateButtonClicked.value = false;
                        this.toastService.createHttpErrorToast(
                            err.error.message,
                            err.status
                        );
                    }
                });
        }
    }

    get smtpHost() {
        return this.systemForm?.get('smtpHost');
    }
    get smtpUserName() {
        return this.systemForm?.get('smtpUserName');
    }
    get smtpPswd() {
        return this.systemForm.get('smtpPswd');
    }
    get smtpPort() {
        return this.systemForm.get('smtpPort');
    }
    get gedHost() {
        return this.systemForm.get('gedHost');
    }
    get gedPswd() {
        return this.systemForm.get('gedPswd');
    }
    get gedUsername() {
        return this.systemForm.get('gedUsername');
    }
    get gedPort() {
        return this.systemForm.get('gedPort');
    }
    get dateDebut() {
        return this.systemForm.get('dateDebut');
    }
    get dateFin() {
        return this.systemForm.get('dateFin');
    }
    get dateDebutRA() {
        return this.systemForm.get('dateDebutRA');
    }
    get dateFinRA() {
        return this.systemForm.get('dateFinRA');
    }
    get typeExport() {
        return this.systemForm.get('typeExport');
    }
    get service() {
        return this.systemForm.get('service');
    }
    get region() {
        return this.systemForm.get('region');
    }
    get typeHandicap() {
        return this.systemForm.get('typeHandicap');
    }

    calculerAge(dateNaissance: string | Date): number {
        const naissance = new Date(dateNaissance);
        const today = new Date();
        let age = today.getFullYear() - naissance.getFullYear();
        const m = today.getMonth() - naissance.getMonth();

        if (m < 0 || (m === 0 && today.getDate() < naissance.getDate())) {
            age--;
        }

        return age;
    }

    onTypeExportChanged(): void{
        const typeExport = this.systemForm.get('typeExport')?.value;
        this.selectedService = null;
        this.selectedRegion = null;
        this.selectedTypeHandicap = null;
        this.showServiceField = false;
        this.showRegionField = false;
        this.showHandicapField = false
        if(typeExport == TypeExportEnum.SERVICE){
            this.showServiceField = true;
        }else if(typeExport == TypeExportEnum.SERVICEREGION){
            this.showServiceField = true;
            this.showRegionField = true;
        }else if(typeExport == TypeExportEnum.TYPEHANDICAP){
            this.showHandicapField = true;
        }
    }

    onServiceChanged(serviceValue) { 
        this.selectedService = this.listService.find(x => x.id == serviceValue.target.value);
        this.listRegion = this.selectedService.regions;
    }

}